<template>
  <div v-if="about">
    <!-- Investor Information -->
    <h3 class="mb-5">Investor Information</h3>
    <div class="h4 mb-5">顯示於AboutUs頁面</div>
    <!-- Call to Action -->
    <label class="form-item pt-5 d-flex">
      <h4 class="w-180px">Call to Action</h4>
      <div class="flex-grow-1 my-n2">
        <v-text-field
          v-model="about.investor_call_to_action"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- img uploader -->
    <div class="form-item py-5 d-flex">
      <div class="w-180px">
        <h4 class="mb-10px">Visual</h4>
        <div class="h5 ink-02-medium--text">
          建議尺寸：650px * 900px <br />
          檔案大小限制：≤ 20 MB <br />
          支援格式：.png/.jpg/.gif
        </div>
      </div>
      <div class="flex-grow-1">
        <ImgUploader
          class="ml-auto"
          :imageUrl.sync="about.investor_visual"
          dir="about"></ImgUploader>
      </div>
    </div>
    <!-- Title -->
    <label class="form-item pt-5 d-flex">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 my-n2">
        <v-textarea
          v-model="about.investor_relations_title"
          outlined
          dense
        ></v-textarea>
      </div>
    </label>
    <!-- Investor Relations Contact -->
    <div class="form-item py-5 d-flex">
      <h4 class="w-180px" style="flex-shrink: 0;">
        Content
      </h4>
      <div class="flex-grow-1 w-540px my-n2">
        <editor
          v-model="about.investor_relations_contact"
          :plugins="'link'"
          :toolbar="'link'"
        />
      </div>
    </div>
    <!-- Title -->
    <label class="form-item pt-5 d-flex">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 my-n2">
        <v-textarea
          v-model="about.investor_agent_title"
          outlined
          dense
        ></v-textarea>
      </div>
    </label>
    <!-- Transfer Agent Contact -->
    <div class="form-item py-5 d-flex">
      <h4 class="w-174px mr-6px" style="flex-shrink: 0;">
        Content
      </h4>
      <div class="flex-grow-1 w-540px my-n2">
        <editor
          v-model="about.investor_agent_contact"
          :plugins="'link'"
          :toolbar="'link'"
        />
      </div>
    </div>

    <!-- Quick Link -->
    <h3 class="my-5">Quick Link</h3>
    <div class="h4 mb-5">可編輯文字及連結，可擴充</div>
    <div class="form-item" v-for="(item, i) in about.investor_quick_link" :key="i">
      <!-- Label -->
      <label class="d-flex align-center my-10px">
        <h5 class="w-174px pr-5">Label {{ i + 1 }}</h5>
        <div class="flex-grow-1">
          <v-text-field
            v-model="item.label"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- URL -->
      <label class="d-flex align-center mb-10px">
        <h5 class="w-174px pr-5">URL</h5>
        <div class="flex-grow-1">
          <v-text-field
            v-model="item.url"
            prepend-inner-icon="mdi-link"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
    </div>
    <!-- add -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon color="brand-01-emphasis" class="mr-2">add_circle</v-icon>
        <span>添加Partner Endorsement</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
    Editor,
  },
  methods: {
    addItem() {
      const template = {
        label: '',
        url: '',
      };
      this.about.investor_quick_link.push(template);
    },
  },
};
</script>

<style></style>
